import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { CasesFiltersResponse, CasesFiltersUrgentOptionsKeys } from '@/api/cases/getCasesFilters';

export interface CasesFiltersOptions extends CasesFiltersResponse {
  isUrgent: CasesFiltersUrgentOptionsKeys[];
}

interface CasesFiltersState {
  filters: CasesFiltersOptions;
  selected: CasesFiltersOptions;
}

const initialState: CasesFiltersState = {
  filters: {
    assignedTo: [],
    createdBy: [],
    status: [],
    isUrgent: []
  },
  selected: {
    assignedTo: [],
    createdBy: [],
    status: [],
    isUrgent: []
  }
};

const casesFiltersSlice = createSlice({
  name: 'casesFilters',
  initialState,
  reducers: {
    setCasesFilters(state, action: PayloadAction<CasesFiltersOptions>) {
      state.filters = action.payload;
    },
    setSelectedCasesFilters(state, action: PayloadAction<CasesFiltersOptions>) {
      state.selected = action.payload;
    },
    resetSelectedCasesFilters(state) {
      state.selected = initialState.selected;
    }
  }
});

export const { setCasesFilters, setSelectedCasesFilters, resetSelectedCasesFilters } = casesFiltersSlice.actions;

export const selectCasesFilters = (state: RootState) => state.casesFilters.filters;
export const selectSelectedCasesFilters = (state: RootState) => state.casesFilters.selected;

export const casesFiltersReducer = casesFiltersSlice.reducer;
